import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
// 持久化
import persistedstate from 'vuex-persistedstate';

import main from './modules/main.js';
import cart from './modules/cart.js';
import coupon from './modules/coupon.js';
import user from './modules/user.js';

export default new Vuex.Store({
  //在严格模式下，无论何时发生了状态变更且不是由 mutation 函数引起的，将会抛出错误
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    main,
    cart,
    coupon,
    user
  },
  plugins: [
    persistedstate({
      storage: window.localStorage
    })
  ]
});



// WEBPACK FOOTER //
// ./src/vuex/index.js